import { useCallback } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useLocaleFormat } from '@/shared/hooks/useLocaleFormat';
import { brandIsPh } from '@/shared/config/brand-by-target.mjs';

import {
  getAuthRedirectTarget,
  getAuthUrlState,
} from './check-and-open-url-rules';

export const useCheckAndOpen = () => {
  const pathname = usePathname();
  const formatUrl = useLocaleFormat();
  const searchParams = useSearchParams();
  const search = searchParams.toString();
  const isCheck = getAuthUrlState({ pathname, search, isPh: brandIsPh });

  const getRedirectPath = useCallback(
    (path: string) => {
      const target = getAuthRedirectTarget({ pathname, search, path });

      return target === null ? null : formatUrl(target);
    },
    [formatUrl, pathname, search]
  );

  return {
    getRedirectPath,
    isCheck,
  };
};
